import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface ConfirmationDialogProps {
  open: boolean;
  onClose?: () => void | undefined;
  title: JSX.Element | string | undefined;
  description: string | JSX.Element;
  buttons?: JSX.Element[] | JSX.Element | undefined;
  maxWidth: false | Breakpoint | undefined;
}

function ConfirmationDialog({
  open,
  onClose,
  title,
  description,
  buttons,
  maxWidth,
}: ConfirmationDialogProps) {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleClose}>Disagree</Button>
        <Button onClick={handleClose} autoFocus>
          Agree
        </Button> */}
        {buttons}
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
